module.exports = require("@swa-ui/core/src/Message/Message.module.scss");